import { Component, OnInit } from '@angular/core';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  group,
  state
} from '@angular/animations';
import { Router, RouterOutlet } from '@angular/router';
import { OnBoardTransitionService } from 'src/app/_services/on-board-transition.service';

@Component({
    selector: 'app-on-board',
    templateUrl: './on-board.component.html',
    styleUrls: ['./on-board.component.scss'],
    animations: [
        trigger('routeAnimations', [
            state('in', style({ opacity: 1, filter: 'blur(0px)' })),
            state('out', style({ opacity: 0, filter: 'blur(2px)' })),
            transition('in => out', [
                animate('300ms ease-out')
            ]),
            transition('out => in', [
                style({ opacity: 0, filter: 'blur(2px)' }),
                animate('400ms ease-in', style({ opacity: 1, filter: 'blur(0px)' }))
            ])
            //   transition('forward => *', [
            //     style({ position: 'relative' }),
            //     query(':enter, :leave', style({
            //       position: 'absolute',
            //       width: '100%',
            //       top: 0,
            //       left: 0
            //     }), { optional: true }),
            //     group([
            //       query(':leave', [
            //         style({ transform: 'translateX(0%)', opacity: 1 }),
            //         animate('400ms ease-in-out', style({ transform: 'translateX(-100%)', opacity: 0 }))
            //       ], { optional: true }),
            //       query(':enter', [
            //         style({ transform: 'translateX(100%)', opacity: 0 }),
            //         animate('400ms ease-in-out', style({ transform: 'translateX(0)', opacity: 1 }))
            //       ], { optional: true })
            //     ])
            //   ]),
            //   transition('backward => *', [
            //     style({ position: 'relative' }),
            //     query(':enter, :leave', style({
            //       position: 'absolute',
            //       width: '100%',
            //       top: 0,
            //       left: 0
            //     }), { optional: true }),
            //     group([
            //       query(':leave', [
            //         style({ transform: 'translateX(0%)', opacity: 1 }),
            //         animate('400ms ease-in-out', style({ transform: 'translateX(100%)', opacity: 0 }))
            //       ], { optional: true }),
            //       query(':enter', [
            //         style({ transform: 'translateX(-100%)', opacity: 0 }),
            //         animate('400ms ease-in-out', style({ transform: 'translateX(0)', opacity: 1 }))
            //       ], { optional: true })
            //     ])
            //   ])
        ])
    ],
    standalone: false
})
export class OnBoardComponent implements OnInit {
animState: 'in' | 'out' = 'in';
pendingRoute: string | null = null;

currentStepIndex = 0;
previousStepIndex = 0;
animationState = 'forward'; // default value
  constructor(private router: Router, private transitionService: OnBoardTransitionService,) {}

  ngOnInit(): void {
      this.transitionService.transition$.subscribe(state => {
      this.animState = state;
    });
  }

   onAnimDone() {
    const route = this.transitionService.getPendingRoute();
    if (this.animState === 'out' && route) {
      this.router.navigate([route]);
      this.transitionService.completeTransition();
    }
  }
/* Carousel wtv*/
//   navigateWithDirection(route: string, stepIndex: number) {
//   this.animationState = stepIndex > this.currentStepIndex ? 'forward' : 'backward';
//   this.previousStepIndex = this.currentStepIndex;
//   this.currentStepIndex = stepIndex;

//   this.router.navigate([route], {
//     state: { direction: this.animationState }
//   });
// }
//   getAnimationState(outlet: RouterOutlet) {
//  return this.animationState;
// }

// getStepIndex(animation: string): number {
//   switch (animation) {
//     case 'Confirm': return 0;
//     case 'Industry': return 1;
//     case 'Workspace': return 2;
//     default: return 0;
//   }
// }


}
